/* eslint-disable no-unused-vars */
import React, { FC, memo, useEffect, useState } from 'react';
import { BranchOptions } from './BranchOption';
import { TemplateOption } from './TemplateOption';
import { TemplateList } from 'src/types';
import { Card, Grid, TextField, Typography } from '@material-ui/core';
import useQuotationProduct from 'src/hooks/quotation-v2/use-quotation-products';
import useQuotationApi from 'src/hooks/quotation-v2/use-quotation-api';

const Component: FC = () => {
  const {
    quotationParams,
    templateDetails,
    setQuotationParams
  } = useQuotationProduct();

  const { fetchTemplateDetails } = useQuotationApi();

  const [templateId, setTemplateId] = useState<string>('');

  useEffect(() => {
    if (templateDetails?.id !== 0) {
      setTemplateId(templateDetails?.id.toString());
    } else {
      setTemplateId('');
    }
  }, [templateDetails.id]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
      <Typography color="textPrimary" variant="h3">
        Quotation V2
      </Typography>

      <Card
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '1em',
          padding: '1em'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Template ID"
              variant="outlined"
              fullWidth
              value={templateId || ''}
              onKeyDown={(e: any) => {
                if (e.key === 'Enter') {
                  const branchId = quotationParams?.branch_id || 1;
                  fetchTemplateDetails({
                    branch_id: branchId,
                    template_id: Number(templateId) || 0
                  });
                }
              }}
              onChange={(e) => setTemplateId(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TemplateOption />
          </Grid>

          <Grid item xs={12} sm={3}>
            <BranchOptions isLoading={false} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              label="Customer Name"
              variant="outlined"
              fullWidth
              onChange={(e) =>
                setQuotationParams({
                  ...quotationParams,
                  customer_name: e.target.value
                })
              }
            />
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export const QuotationV2Toolbar = memo(Component);
